/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { scroller } from "react-scroll";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import RodoContent from '../../components/RodoContent';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import { isMobileView, isTabletView, renderHelpDesc, isSuperAdminRole } from '../../components/utils/utils';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import Select from 'react-select';
import agentConfig from './agent';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import loadingData from './loading';
import { showDraftsCondition, saveDraft, areEqual, getDraft, getDraftDataFromState } from '../../components/DraftManagement/draftManager';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import { trackEvent } from '../../lib/utils';
import ButtonsPanel from './utils/ButtonsPanel';
import { bodyStyle, redirectToSummary } from './constants';


import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
};

const treeOptions = [
  {
    state: 'typeTree',
    value: 'kasztanowiec zwyczajny',
    label: 'kasztanowiec zwyczajny',
  },
  {
    state: 'typeTree',
    value: 'klon jesionolistny',
    label: 'klon jesionolistny',
  },
  {
    state: 'typeTree',
    value: 'klon srebrzysty',
    label: 'klon srebrzysty',
  },
  {
    state: 'typeTree',
    value: 'platan klonolistny',
    label: 'platan klonolistny',
  },
  {
    state: 'typeTree',
    value: 'robinia akacjowa',
    label: 'robinia akacjowa',
  },
  {
    state: 'typeTree',
    value: 'topola',
    label: 'topola',
  },
  {
    state: 'typeTree',
    value: 'wierzba',
    label: 'wierzba',
  },
  {
    state: 'typeTree',
    value: 'brzoza',
    label: 'brzoza',
  },
  {
    state: 'typeTree',
    value: 'czeremcha',
    label: 'czeremcha',
  },
  {
    state: 'typeTree',
    value: 'czereśnia',
    label: 'czereśnia',
  },
  {
    state: 'typeTree',
    value: 'daglezja',
    label: 'daglezja',
  },
  {
    state: 'typeTree',
    value: 'dąb czerwony',
    label: 'dąb czerwony',
  },
  {
    state: 'typeTree',
    value: 'glediczja trójcierniowa',
    label: 'glediczja trójcierniowa',
  },
  {
    state: 'typeTree',
    value: 'jesion',
    label: 'jesion',
  },
  {
    state: 'typeTree',
    value: 'jodła',
    label: 'jodła',
  },
  {
    state: 'typeTree',
    value: 'kasztan jadalny',
    label: 'kasztan jadalny',
  },
  {
    state: 'typeTree',
    value: 'kasztanowiec',
    label: 'kasztanowiec',
  },
  {
    state: 'typeTree',
    value: 'klon czerwony',
    label: 'klon czerwony',
  },
  {
    state: 'typeTree',
    value: 'klon jawor',
    label: 'klon jawor',
  },
  {
    state: 'typeTree',
    value: 'klon zwyczajny',
    label: 'klon zwyczajny',
  },
  {
    state: 'typeTree',
    value: 'lipa',
    label: 'lipa',
  },
  {
    state: 'typeTree',
    value: 'metasekwoja chińska',
    label: 'metasekwoja chińska',
  },
  {
    state: 'typeTree',
    value: 'modrzew',
    label: 'modrzew',
  },
  {
    state: 'typeTree',
    value: 'olcha',
    label: 'olcha',
  },
  {
    state: 'typeTree',
    value: 'orzech',
    label: 'orzech',
  },
  {
    state: 'typeTree',
    value: 'sofora chińska',
    label: 'sofora chińska',
  },
  {
    state: 'typeTree',
    value: 'sosna',
    label: 'sosna',
  },
  {
    state: 'typeTree',
    value: 'sumak',
    label: 'sumak',
  },
  {
    state: 'typeTree',
    value: 'świerk',
    label: 'świerk',
  },
  {
    state: 'typeTree',
    value: 'wiąz',
    label: 'wiąz',
  },
  {
    state: 'typeTree',
    value: 'wiśnia',
    label: 'wiśnia',
  },
  {
    state: 'typeTree',
    value: 'żywotnik olbrzymi',
    label: 'żywotnik olbrzymi',
  },
  {
    state: 'typeTree',
    value: 'ałycza',
    label: 'ałycza',
  },
  {
    state: 'typeTree',
    value: 'ambrowiec balsamiczny',
    label: 'ambrowiec balsamiczny',
  },
  {
    state: 'typeTree',
    value: 'buk pospolity',
    label: 'buk pospolity',
  },
  {
    state: 'typeTree',
    value: 'choina kanadyjska',
    label: 'choina kanadyjska',
  },
  {
    state: 'typeTree',
    value: 'cypryśnik błotny',
    label: 'cypryśnik błotny',
  },
  {
    state: 'typeTree',
    value: 'dąb',
    label: 'dąb',
  },
  {
    state: 'typeTree',
    value: 'grab pospolity',
    label: 'grab pospolity',
  },
  {
    state: 'typeTree',
    value: 'grusza',
    label: 'grusza',
  },
  {
    state: 'typeTree',
    value: 'jabłoń',
    label: 'jabłoń',
  },
  {
    state: 'typeTree',
    value: 'jarząb pospolity',
    label: 'jarząb pospolity',
  },
  {
    state: 'typeTree',
    value: 'klon polny',
    label: 'klon polny',
  },
  {
    state: 'typeTree',
    value: 'kłęk amerykański',
    label: 'kłęk amerykański',
  },
  {
    state: 'typeTree',
    value: 'korkowiec amurski',
    label: 'korkowiec amurski',
  },
  {
    state: 'typeTree',
    value: 'leszczyna turecka',
    label: 'leszczyna turecka',
  },
  {
    state: 'typeTree',
    value: 'magnolia',
    label: 'magnolia',
  },
  {
    state: 'typeTree',
    value: 'miłorząb japoński',
    label: 'miłorząb japoński',
  },
  {
    state: 'typeTree',
    value: 'morwa',
    label: 'morwa',
  },
  {
    state: 'typeTree',
    value: 'orzesznik',
    label: 'orzesznik',
  },
  {
    state: 'typeTree',
    value: 'rokitnik zwyczajny',
    label: 'rokitnik zwyczajny',
  },
  {
    state: 'typeTree',
    value: 'surmia',
    label: 'surmia',
  },
  {
    state: 'typeTree',
    value: 'tulipanowiec amerykański',
    label: 'tulipanowiec amerykański',
  },
  {
    state: 'typeTree',
    value: 'wiśnia wonna',
    label: 'wiśnia wonna',
  },
  {
    state: 'typeTree',
    value: 'cis',
    label: 'cis',
  },
  {
    state: 'typeTree',
    value: 'cyprysik',
    label: 'cyprysik',
  },
  {
    state: 'typeTree',
    value: 'głóg',
    label: 'głóg',
  },
  {
    state: 'typeTree',
    value: 'jałowiec',
    label: 'jałowiec',
  },
  {
    state: 'typeTree',
    value: 'jarząb',
    label: 'jarząb',
  },
  {
    state: 'typeTree',
    value: 'jodła koreańska',
    label: 'jodła koreańska',
  },
  {
    state: 'typeTree',
    value: 'oliwnik',
    label: 'oliwnik',
  },
  {
    state: 'typeTree',
    value: 'żywotnik zachodni',
    label: 'żywotnik zachodni',
  },
  {
    state: 'typeTree',
    value: 'inny rodzaj/gatunek drzewa',
    label: 'inny rodzaj/gatunek drzewa',
  },
];

const shrubOptions = [
  {
    state: 'typeShrub',
    value: 'dereń rozłogowy',
    label: 'dereń rozłogowy',
  },
  {
    state: 'typeShrub',
    value: 'róża pomarszczona',
    label: 'róża pomarszczona',
  },
  {
    state: 'typeShrub',
    value: 'sumak',
    label: 'sumak',
  },
  {
    state: 'typeShrub',
    value: 'tawuła kutnerowata',
    label: 'tawuła kutnerowata',
  },
  {
    state: 'typeShrub',
    value: 'świdośliwa kłosowa',
    label: 'świdośliwa kłosowa',
  },
  {
    state: 'typeShrub',
    value: 'inny rodzaj/gatunek krzewu',
    label: 'inny rodzaj/gatunek krzewu',
  },
];


const AdditionalInfoDict = {
  reasonRemoveTree: {
    label: 'Przyczyna zamierzonego usunięcia drzew/krzewów',
    editable: true,
    type: 'textarea'
  },
  dateOfRemove: {
    label: 'Termin zamierzonego usunięcia drzew/krzewów:',
    editable: true,
  },
};

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
};

const optionsWnioskodawca = [
  { target: { name: "oswiadczenie", value: 'Właścicielem nieruchomości' }, value: 'Właścicielem nieruchomości', label: 'Właścicielem nieruchomości' },
  { target: { name: "oswiadczenie", value: 'Współwłaścicielem nieruchomości' }, value: 'Współwłaścicielem nieruchomości', label: 'Współwłaścicielem nieruchomości - należy uzupiełnić załącznik 1 - zgodę wszystkich współwłaścicieli nieruchomości na usunięcie drzew/krzewów' },
  { target: { name: "oswiadczenie", value: 'Użytkownikiem wieczystym nieruchomości' }, value: 'Użytkownikiem wieczystym nieruchomości', label: 'Użytkownikiem wieczystym nieruchomości' },
  { target: { name: "oswiadczenie", value: 'Posiadaczem nieruchomości' }, value: 'Posiadaczem nieruchomości', label: 'Posiadaczem nieruchomości - do wniosku należy dołączyć tytuł prawny władania nieruchomością i zgodę właściciela tej nieruchomości na usunięcie drzew/krzewów' },
  { target: { name: "oswiadczenie", value: 'Właścicielem urządzeń, o których mowa w art. 49 § 1 ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny' }, value: 'Właścicielem urządzeń, o których mowa w art. 49 § 1 ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny', label: 'Właścicielem urządzeń, o których mowa w art. 49 § 1 ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny' }
];

const optionsJest = [
  { target: { name: 'jest', value: 'jest' }, value: 'jest', label: 'jest' },
  { target: { name: 'jest', value: 'nie jest' }, value: 'nie jest', label: 'nie jest' },
]

const optionsPlanuje = [
  { target: { name: 'planuje', value: 'planuje' }, value: 'planuje', label: 'planuje' },
  { target: { name: 'planuje', value: 'nie planuje' }, value: 'nie planuje', label: 'nie planuje' },
]

const optionsNatura2000 = [
  { target: { name: 'natura2000', value: 'wynika' }, value: 'wynika', label: 'wynika' },
  { target: { name: 'natura2000', value: 'nie wynika' }, value: 'nie wynika', label: 'nie wynika' },
]

const optionszezwGatChr = [
  { target: { name: 'zezwGatChr', value: 'zostało' }, value: 'zostało', label: 'zostało' },
  { target: { name: 'zezwGatChr', value: 'nie zostało' }, value: 'nie zostało', label: 'nie zostało' },
]

const stateToDraft = [
  "info",
  "additionalInfo",
  "wnioskodawca",
  "listTrees",
  "listShrubs",
  "selectedParcels",
  "selectedRoads",
  "attachments",
];


class UsuniecieDrzew extends React.Component {
  state = {
    additionalInfo: {
      reasonRemoveTree: null,
      dateOfRemove: null,
    },
    wnioskodawca: {
      oswiadczenie: null,
      jest: null,
      planuje: null,
      natura2000: null,
      zezwGatChr: null,
    },
    listTrees: [],
    listShrubs: [],
    info: {
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    treeErrors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    draftAttachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
    showDrafts: false,
  };

  validators = {
    AddressCity: [v.NotNull, v.MinLength(2)],
    AddressStreet: [v.NotNull],
    AddressFlat: [v.NotNull, v.isNumber],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    reasonRemoveTree: [v.NotNull],
    dateOfRemove: [v.NotNull],
    oswiadczenie: [v.NotSelected],
    jest: [v.NotSelected],
    planuje: [v.NotSelected],
    natura2000: [],
    zezwGatChr: [],
    dzialalnosc: [v.NotNull],
    typeTree: [v.NotSelected],
    circuitTree: [v.NotNull, v.isNumber],
    amountTrees: [v.NotNull, v.isNumber],
    typeShrub: [v.NotSelected],
    areaShrub: [v.NotNull, v.isNumber],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  async componentDidMount() {
    const showDrafts = showDraftsCondition(this.props.prefix);
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          showDrafts: showDrafts,
        }, this.updateValidators());
      });

    if (showDrafts) {
      const draftData = await getDraft(this.props.prefix, this.props.serviceInfo.eservice.shortName);

      if (draftData) {
        this.setState({ ...draftData, draftAttachments: draftData.attachments, isMounted: true }, () => {
          window.dispatchEvent(
            new CustomEvent("draft:loaded")
          );
        });
      } else {
        this.setState({ isMounted: true });
      }
    } else {
      this.setState({
        isMounted: true
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDrafts) {
      if (!this.state.isMounted) return;

      if (!prevState.isMounted && this.state.isMounted) return;

      const prevDraft = getDraftDataFromState(prevState, stateToDraft);
      const currentDraft = getDraftDataFromState(this.state, stateToDraft);

      if (this.props.serviceInfo.user && !areEqual(prevDraft, currentDraft)) {
        saveDraft(
          currentDraft,
          this.props.prefix,
          this.props.serviceInfo.eservice.shortName
        );
      }
    }
  }

  handleManualDraftSave = () => {
    const draft = getDraftDataFromState(this.state, stateToDraft);

    saveDraft(
      draft,
      this.props.prefix,
      this.props.serviceInfo.eservice.shortName,
      { debounce: false } // wymuszony zapis
    );
  };

  updateValidators = () => {
    if (['gmina_olesno_powiat_oleski', 'gmina_ilawa'].includes(this.props.prefix)) {
      this.validators.planuje = [];
    }
    if (['gmina_ilawa'].includes(this.props.prefix)) {
      this.validators.natura2000 = [v.NotSelected];
      this.validators.zezwGatChr = [v.NotSelected];
    }
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  addTree = () => {
    this.setState({
      listTrees: [...this.state.listTrees, {
        typeTree: '',
        circuitTree: '',
        amountTrees: '',
      }],
    }, this.validateTrees);
  }

  addShrub = () => {
    this.setState({
      listShrubs: [...this.state.listShrubs, {
        typeShrub: '',
        areaShrub: '',
      }],
    }, this.validateTrees);
  }

  removeTree = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list
      }, this.validateTrees
    );
  }

  onChangeTree = (e, state, elem, index) => {
    const arr = [...this.state[state]];      // kopia tablicy
    const updatedItem = { ...arr[index] };  // kopia obiektu

    updatedItem[elem] = e.target.value;
    arr[index] = updatedItem;

    this.setState(
      { [state]: arr },
      () => this.validateTrees(state, elem, index)
    );
  };

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  getInputWithError = (group, field, idx, value, placeholder) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.treeErrors).indexOf(`${field}${idx}`) > -1 &&
              this.state.treeErrors[`${field}${idx}`] !== null &&
              this.state.treeErrors[`${field}${idx}`].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={value}
        placeholder={placeholder}
        onChange={(e) => this.onChangeTree(e, group, field, idx)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.treeErrors).indexOf(`${field}${idx}`) > -1 &&
        this.state.treeErrors[`${field}${idx}`] !== null &&
        this.state.treeErrors[`${field}${idx}`].length > 0
        ? this.state.treeErrors[`${field}${idx}`].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangeTreeSelect = (e, state, elem, index) => {
    const arr = [...this.state[state]];           // kopia tablicy
    const updatedItem = { ...arr[index] };       // kopia obiektu

    updatedItem[elem] = e.value;
    arr[index] = updatedItem;

    this.setState(
      { [state]: arr },
      () => this.validateTrees(state, elem, index)
    );
  };


  validateTrees = (group = null, field = null, index = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateTreeField(group, field, index);
      newState = {
          ...this.state.treeErrors,
          [`${field}${index}`]: checks,
      };
    } else {
      let errors = {};
      const grupy = ['listTrees', 'listShrubs'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { ...errors };
    }

    if (newState) {
      this.setState({ treeErrors: newState });
    }
  };

  validateTreeField = (group, field, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validateTreeField(group, field, idx);
          errors[`${field}${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };


  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["additionalInfo", "wnioskodawca"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...this.state.errors, ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    for (const key of Object.keys(this.state.treeErrors)) {
      if (this.state.treeErrors[key].length > 0) return true;
    }
    return false;
  };

  scrollToSection = (field) => {
    scroller.scrollTo(field, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -400,
    });
  };

  insertTestData = () => {
    this.setState({
      additionalInfo: {
        reasonRemoveTree: 'Porzadki',
        dateOfRemove: '12.02.2019',
      },
      listTrees: [{
        typeTree: 'brzoza',
        circuitTree: '145',
        amountTrees: '12',
      }],
      listShrubs: [{
        typeShrub: 'sumak',
        areaShrub: '15',
      }],
      wnioskodawca: {
        oswiadczenie: 'Właścicielem nieruchomości',
        jest: 'jest',
        planuje: 'nie planuje',
        natura2000: 'nie wynika',
        zezwGatChr: 'nie zostało',
      },
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = async () => {
    await this.validateTrees();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => this.scrollToSection('CustomizedMapScroll'));
      return;
    }

    if (this.state.listShrubs.length === 0 && this.state.listTrees.length === 0) {
      this.setState({
        errorText: 'Należy wybrać co najmniej jedno drzewo lub krzew.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => this.scrollToSection('TreeSelection'));
      return;
    }

    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          additionalInfo: { ...this.state.additionalInfo },
          wnioskodawca: { ...this.state.wnioskodawca },
          listShrubs: this.state.listShrubs,
          listTrees: this.state.listTrees,
          dzialki: this.state.selectedParcels,
          info: { ...this.state.info },
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () => {
              trackEvent({
                category: 'application',
                action: 'click',
                name: this.props.serviceInfo.eservice.title,
              });
              redirectToSummary(resp.jobId);
            }
          );
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  getSelectWithError = (group, field, idx, value, options) => (
    <div style={{ textAlign: 'justify' }}>
      <Select
        noResultsText={'brak wyników'}
        clearable={false}
        options={options}
        value={value}
        placeholder={'Wybierz z listy...'}
        onChange={e => this.onChangeTreeSelect(e, group, field, idx)}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.treeErrors).indexOf(`${field}${idx}`) > -1 &&
              this.state.treeErrors[`${field}${idx}`] !== null &&
              this.state.treeErrors[`${field}${idx}`].length > 0
              ? 'red'
              : '#ccc',
        }}
        onBlur={event => event.preventDefault()}
        optionClassName="needsclick"
        blurInputOnSelect={false}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.treeErrors).indexOf(`${field}${idx}`) > -1 &&
        this.state.treeErrors[`${field}${idx}`] !== null &&
        this.state.treeErrors[`${field}${idx}`].length > 0
        ? this.state.treeErrors[`${field}${idx}`].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getExtraPanel = (title, description, label, group, state, selectOptions) => (
    <GrayPanel title={title}>
      <div className="row">
        <div className="col-sm-12">
          {description}
        </div>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <label htmlFor={group}>{label}</label>
        </div>
        <div className="col-sm-6">
          <Select
            clearable={false}
            placeholder="Wybierz z listy..."
            options={selectOptions}
            value={this.state[group][state]}
            onChange={(e) => this.onChange(e, group)}
            style={this.getStandartInputErrorStyle(state)}
            onBlur={event => event.preventDefault()}
            optionClassName="needsclick"
            blurInputOnSelect={false}
          />
          {this.renderErrorsInSpan(state)}
        </div>
        <div className="col-sm-2" />
      </div>
    </GrayPanel>
  )

  renderErrorsInSpan = (state) => {
    if (Object.keys(this.state.errors).indexOf(state) > -1 &&
      this.state.errors[state] !== null &&
      this.state.errors[state].length > 0) {
      const span = this.state.errors[state].map((val, index) => (
        <span key={index} style={errorSpanStyle}>
          {val}
        </span>
      ))
      return span;
    } return null;
  }

  getStandartInputErrorStyle = (state) => {
    const standardInputErrStyle = {
      width: '100%',
      borderColor:
        Object.keys(this.state.errors).indexOf(state) > -1 &&
          this.state.errors[state] !== null &&
          this.state.errors[state].length > 0
          ? 'red'
          : '#ccc',
    };
    return standardInputErrStyle;
  }

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    const panel5Title = "5. Oświadczenie wnioskodawcy";
    const panel5Description = <p>
      Oświadczam, pod rygorem odpowiedzialności karnej wynikającej z art. 233 §1 ustawy z dnia 6 czerwca 1997r.
      Kodeks karny (tekst jednolity DZ. U. z 2020 poz. 1444 z późniejszymi zmianami), iż wnioskodawca
      jest: {this.state.wnioskodawca.oswiadczenie ? <b>{this.state.wnioskodawca.oswiadczenie}</b> : '...'}
    </p>;
    const panel5Label = "Wnioskodawca jest:";

    const panel6Title = "6. Oświadczenie wnioskodawcy";
    const panel6Description = <p>
      Oświadczam, że usunięcie objętych niniejszym wnioskiem drzew/krzewów {this.state.wnioskodawca.jest ? <b>{this.state.wnioskodawca.jest}</b> : '...'} związane z prowadzeniem
      działalności gospodarczej w rozumieniu przepisów ustawy z dnia 2 lipca 2004 r. o swobodzie działalności
      gospodarczej (tekst jednolity Dz. U. 2017 r. poz. 2168 z późniejszymi zmianami)
    </p>
    const panel6Label = "Czy usunięcie drzew jest związane z prowadzeniem działalności gospodarczej?"
    
    const panel7Title = "7. Oświadczenie wnioskodawcy";
    const panel7Description = <p>
      Oświadczam, że wnioskodawca {this.state.wnioskodawca.planuje ? <b>{this.state.wnioskodawca.planuje}</b> : '...'} wykonanie nasadzeń zastępczych (w przypadku planowania nasadzeń zastępczych
      należy do wniosku załączyć załącznik nr 2).
    </p>;
    const panel7Label = "Czy wnioskodawca planuje wykonanie nasadzeń zastępczych?";

    const panel8Title = "Natura 2000 - Oświadczenie wnioskodawcy";
    const panel8Description = <p>
      Oświadczam, że planowane usunięcie {this.state.wnioskodawca.natura2000 ? <b>{this.state.wnioskodawca.natura2000}</b> : '...'} z realizacji przedsięwzięcia, dla którego wymagane jest uzyskanie decyzji o środowiskowych uwarunkowaniach albo postanowienia w sprawie uzgodnienia warunków realizacji przedsięwzięcia  w zakresie oddziaływania na obszar Natura 2000
    </p>;
    const panel8Label = "Czy planowane usunięcie wynika z realizacji przedsięwzięcia, dla którego wymagane jest uzyskanie decyzji o środowiskowych uwarunkowaniach albo postanowienia w sprawie uzgodnienia warunków realizacji przedsięwzięcia  w zakresie oddziaływania na obszar Natura 2000?";

    const panel9Title = "Zezwolenie w stosunku do gatunków chronionych  - Oświadczenie wnioskodawcy";
    const panel9Description = <p>
      Oświadczam, że w z związku z planowaną wycinką {this.state.wnioskodawca.zezwGatChr ? <b>{this.state.wnioskodawca.zezwGatChr}</b> : '...'} wydane zezwolenie w stosunku do gatunków chronionych na czynności podlegające zakazom określonym w art. 51 ust. 1 pkt 1-4 i 10 oraz w art. 52 ust. 1 pkt 1, 3, 7, 8, 12, 13 i 15 ustawy z dnia 16 kwietnia 2014 r. o ochronie przyrody.
    </p>;
    const panel9Label = "Czy w związku z planowaną wycinką wydane zostało zezwolenie w stosunku do gatunków chronionych na czynności podlegające zakazom określonym w art. 51 ust. 1 pkt 1-4 i 10 oraz w art. 52 ust. 1 pkt 1, 3, 7, 8, 12, 13 i 15 ustawy z dnia 16 kwietnia 2014 r. o ochronie przyrody?";
   
    if (this.state.isMounted) {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Adres'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <div id='CustomizedMapScroll'></div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
            treeSelection
            showPdfExport
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <GrayPanel title={'2. Lista drzew'}>
          <div className="row">
            <div className="col-sm-8">
              Nazwa gatunku drzewa i obwód pnia mierzony na wysokości 130 cm, a w przypadku gdy na tej wysokości drzewo
              posiada kilka pni - obwód każdego z tych pni bądź nie posiada pnia - obwód pnia bezpośrednio poniżej korony
          </div>
            <div className="col-sm-4">
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'right', ...btnStyle }}
                onClick={() => this.addTree()}
              >
                Dodaj drzewo
            </button>
            </div>
          </div>
          <table className="table" id={'TreeSelection'}>
            <thead>
              <tr>
                <th scope="col">LP</th>
                <th scope="col">Gatunek drzewa</th>
                <th scope="col">Obwód [cm]</th>
                <th scope="col">Ilość sztuk</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.listTrees.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      {this.getSelectWithError('listTrees', 'typeTree', i, v.typeTree, treeOptions)}
                    </td>
                    <td>
                      {this.getInputWithError('listTrees', 'circuitTree', i, v.circuitTree, 'Obwód drzewa...')}
                    </td>
                    <td>
                      {this.getInputWithError('listTrees', 'amountTrees', i, v.amountTrees, 'Ilość...')}
                    </td>
                    <td>
                      <button
                        type="submit-lg"
                        className={'btn btn-danger'}
                        style={{ btnStyle }}
                        onClick={() => this.removeTree(i, 'listTrees')}
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </GrayPanel>

        <GrayPanel title={'3. Lista krzewów'}>
          <div className="row">
            <div className="col-sm-8">
              Nazwa gatunkowa krzewów i wielkość powierzchni z której zostaną usunięte.
            </div>
            <div className="col-sm-4">
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'right', ...btnStyle }}
                onClick={() => this.addShrub()}
              >
                Dodaj krzew
              </button>
            </div>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">LP</th>
                <th scope="col">Gatunek krzewu</th>
                <th scope="col">Powierzchnia [m<sup>2</sup>]</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.listShrubs.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      {this.getSelectWithError('listShrubs', 'typeShrub', i, v.typeShrub, shrubOptions)}
                    </td>
                    <td>
                      {this.getInputWithError('listShrubs', 'areaShrub', i, v.areaShrub, 'Powierzchnia...')}
                    </td>
                    <td>
                      <button
                        type="submit-lg"
                        className={'btn btn-danger'}
                        style={{ btnStyle }}
                        onClick={() => this.removeTree(i, 'listShrubs')}
                      >
                        Usuń
                        </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </GrayPanel>

        <DecisionContainer
          title={'4. Dodatkowe informacje'}
          data={this.state.additionalInfo}
          errors={this.state.errors}
          formDict={AdditionalInfoDict}
          onChange={e => this.onChange(e, 'additionalInfo')}
        />
        {this.getExtraPanel(panel5Title, panel5Description, panel5Label, 'wnioskodawca', 'oswiadczenie', optionsWnioskodawca)}
        {this.getExtraPanel(panel6Title, panel6Description, panel6Label, 'wnioskodawca', 'jest', optionsJest)}

        {!['gmina_olesno_powiat_oleski', 'gmina_ilawa'].includes(this.props.prefix) ? this.getExtraPanel(panel7Title, panel7Description, panel7Label, 'wnioskodawca', 'planuje', optionsPlanuje) : null}

        {['gmina_ilawa'].includes(this.props.prefix) ? this.getExtraPanel(panel8Title, panel8Description, panel8Label, 'wnioskodawca', 'natura2000', optionsNatura2000) : null}
        {['gmina_ilawa'].includes(this.props.prefix) ? this.getExtraPanel(panel9Title, panel9Description, panel9Label, 'wnioskodawca', 'zezwGatChr', optionszezwGatChr) : null}

        {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
          <GrayPanel title={"Informacja dla wnioskodawcy"}>
            <div className="row">
              <div className="col-sm-12">
                <p>Opłata za wydanie zezwolenia na wycinkę drzewa lub krzewu wynika z decyzji. Wyłączenie z opłaty wynika z art. 86 ustawy o ochronie przyrody.</p>
                < br />
                <p>Do niniejszego wniosku należy dołączyć załączniki:</p>
                <p>1. Oświadczenie współwłaścicieli - w przypadku działki stanowiącej współwłasność</p>
                <p>2. Rysunek, mapa albo wykonany przez projektanta posiadającego odpowiednie uprawnienia budowalane
                  projekt zagospodarowania działki lub terenu w przypadku realizacji inwestycji, dla której jest on wymagany
                  zgodnie z ustawą z dnia 7 lipca 1994 r. - Prawo budowalane - określające ustytuowanie drzewa lub krzewu
                  w odniesieniu do granic nieruchomości i obiektów budowalanych istniejących lub projektowanych tej nieruchomości.
                  </p>
                <p>3. Projekt plany:<br />
                  a) nasadzeń zastępczych, rozumianych jako posadzenie drzew lub krzewów, w liczbie nie mniejszej niż liczba usuwanych
                  drzew lub o powierzchni nie mniejszej niż powierzchnia usuwanych krzewów, stanowiących kompensację przyrodniczą za
                  usuwane drzewa i krzewy w rozumieniu art. 3 pkt 8 ustawy z dnia 27 kwietnia 2001 r. - Prawo ochrony środowiska<br />
                  b) przeniesienia drzewa lub krzewu - jeżeli są planowane, wykonany w formie rysunku, mapy lub projektu zagospodarowania
                  działki lub tereny, oraz informację o liczbie, gatunku lub odmianie drzew lub krzewów oraz miejscu i planowanym terminie
                  ich wykonania.</p>
                <p>4. Decyzja o środowiskowych uwarunkowaniach albo postanowienie w sprawie uzgodnienia warunków realizacji
                  przedsięwzięcia w zakresie oddziaływania na obszar Natura 2000, w przypadku realizacji przedsięwzięcia,
                  dla którego wymagane jest ich uzyskanie zgodnie z ustawą z dnia 3 października 2008 r. o udostępnianiu
                  informacji o środowisku i jego ochronie, udziale społeczeństwa w ochronie środowiska oraz o ocenach
                  oddziaływania na środowisko, oraz postanowienie uzgadniające wydawane przez właściwego regionalnego
                  dyrektora ochorny środowiska w ramach pewnej oceny oddziaływania na środowisko, jeżeli jest wymagana lub została
                  przeprowadzona na wniosek realizującego przedsięwzięcie.
                  </p>
                <p>
                  5. Zezwolenie w stosunku do gatunków chronionych na czynności podlegające zakazom określonym w art. 51 ust. 1 pkt 1-40
                  i 10 oraz w art. 52 ust. 1 pkt 1,3,7,8,12,13 i 15 ustaw z dnia 16 kwietnia 2004 r. o ochronie przyrody (tekst jednolity
                  Dz. U. z 2020 r. poz. 55 z późniejszymi zmianami), jeżeli zostało wydane.
                  </p>
                <p>
                  6. Decyzja o warunkach zabudowy/ o lokalizacji inwestycji celu publicznego,
                </p>
                <p>
                  7. Kopia decyzji o pozwoleniu na budowę
                </p>
              </div>
            </div>
          </GrayPanel>
          :
          <GrayPanel title={"Informacja dla wnioskodawcy"}>
            <div className="row">
              <div className="col-sm-12">
                <p>Do niniejszego wniosku należy dołączyć załączniki:</p>
                <p>1. Oświadczenie współwłaścicieli - w przypadku działki stanowiącej współwłasność</p>
                <p>2. Rysunek, mapa albo wykonany przez projektanta posiadającego odpowiednie uprawnienia budowalane
                  projekt zagospodarowania działki lub terenu w przypadku realizacji inwestycji, dla której jest on wymagany
                  zgodnie z ustawą z dnia 7 lipca 1994 r. - Prawo budowalane - określające ustytuowanie drzewa lub krzewu
                  w odniesieniu do granic nieruchomości i obiektów budowalanych istniejących lub projektowanych tej nieruchomości.
                  </p>
                <p>3. Projekt plany:<br />
                  a) nasadzeń zastępczych, rozumianych jako posadzenie drzew lub krzewów, w liczbie nie mniejszej niż liczba usuwanych
                  drzew lub o powierzchni nie mniejszej niż powierzchnia usuwanych krzewów, stanowiących kompensację przyrodniczą za
                  usuwane drzewa i krzewy w rozumieniu art. 3 pkt 8 ustawy z dnia 27 kwietnia 2001 r. - Prawo ochrony środowiska<br />
                  b) przeniesienia drzewa lub krzewu - jeżeli są planowane, wykonany w formie rysunku, mapy lub projektu zagospodarowania
                  działki lub tereny, oraz informację o liczbie, gatunku lub odmianie drzew lub krzewów oraz miejscu i planowanym terminie
                  ich wykonania.</p>
                <p>4. Decyzja o środowiskowych uwarunkowaniach albo postanowienie w sprawie uzgodnienia warunków realizacji
                  przedsięwzięcia w zakresie oddziaływania na obszar Natura 2000, w przypadku realizacji przedsięwzięcia,
                  dla którego wymagane jest ich uzyskanie zgodnie z ustawą z dnia 3 października 2008 r. o udostępnianiu
                  informacji o środowisku i jego ochronie, udziale społeczeństwa w ochronie środowiska oraz o ocenach
                  oddziaływania na środowisko, oraz postanowienie uzgadniające wydawane przez właściwego regionalnego
                  dyrektora ochorny środowiska w ramach pewnej oceny oddziaływania na środowisko, jeżeli jest wymagana lub została
                  przeprowadzona na wniosek realizującego przedsięwzięcie.
                  </p>
                <p>
                  5. Zezwolenie w stosunku do gatunków chronionych na czynności podlegające zakazom określonym w art. 51 ust. 1 pkt 1-40
                  i 10 oraz w art. 52 ust. 1 pkt 1,3,7,8,12,13 i 15 ustaw z dnia 16 kwietnia 2004 r. o ochronie przyrody (tekst jednolity
                  Dz. U. z 2020 r. poz. 55 z późniejszymi zmianami), jeżeli zostało wydane.
                  </p>
              </div>
            </div>
          </GrayPanel>}
        
        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel
          onChangeAttachments={this.onChangeAttachments}
          showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}
          draftAttachments={this.state.draftAttachments}
        />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <ButtonsPanel
          prefix={this.props.prefix}
          shortName={this.props.serviceInfo.eservice.shortName}
          serviceTitle={this.props.serviceInfo.eservice.title}
          showDrafts={this.state.showDrafts}
          onDraftSave={this.handleManualDraftSave}
          onSave={() => this.setState({ loading: true }, () => this.startService())}
          onCancel={history.goBack}
        />

        <div className="col-sm-12" style={{ paddingLeft: '0px' }}>
          {(this.props.serviceInfo.user && isSuperAdminRole(this.props.serviceInfo.user.roles)) ? (
            <button
              type="submit-lg"
              className="btn btn-success"
              style={{ float: 'left', marginLeft: '10px', ...btnStyle }}
              onClick={this.insertTestData}
            >
              Insert Test Data
            </button>
          ) : null}
        </div>
      </div>
    );
    }
    return (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={bodyStyle}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>
    );
  }
}

UsuniecieDrzew.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UsuniecieDrzew),
);



// WEBPACK FOOTER //
// src/routes/eservices/UsuniecieDrzew.js